import { NgModule } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import { UsersService } from '../../../../injections/users.service';
import { Subject, Subscription } from 'rxjs/Rx';


@Component({
  selector: 'users-list',
  templateUrl: '../../templates/partials/users.html',

})
export class UsersComponent implements OnInit{

    users_object: any;
    subscription: Subscription;
    @Input() users;
    constructor(private usersService: UsersService){
    }

    public goDetail(id: string) {

    }

    public getUsers(): void {
      //this.usersService.getUsers().then(heroes => this.users = heroes);
    }
    
    ngOnInit() {
    
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/users.component.ts